import Vue from 'vue';
import Component from 'vue-class-component';
import TheToolbarDesktop from './TheToolbarDesktop.vue'
import TheToolbarMobile from './TheToolbarMobile.vue'


@Component({
    components: {
        TheToolbarDesktop,
        TheToolbarMobile
    }
})
export default class TheToolbar extends Vue {
}